var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.IconButton,{attrs:{"title":_setup.title,"layout":_setup.IconButtonLayout.HORIZONTAL,"icon":_setup.LanguageIcon},on:{"click-icon":_setup.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }